<template>
  <div>
    <h5 class="sub-tilte-page mt-5 text-center mb-4">Researchers</h5>
    <div class="row text-muted" style="font-size:13px;">
      <div class="col-lg-4 col-12 text-center mb-3">
        <p class="mb-0">JAPHET LOUIS O. TANTIANGCO</p>
        <p class="mb-0">Research Manager</p>
        <p class="mb-0">+63 (2) 8588-1927</p>
      </div>
      <div class="col-lg-4 col-12 text-center mb-3">
        <p class="mb-0">CLAIRE T. ALVIAR</p>
        <p class="mb-0">Asst. Manager Research and Online Engagement</p>
        <p class="mb-0">+63 (2) 8588-1925</p>
      </div>
      <div class="col-lg-4 col-12 text-center mb-3">
        <p class="mb-0">MIKHAIL PHILIPPE Q. PLOPENIO</p>
        <p class="mb-0">Research and Engagement Officer</p>
        <p class="mb-0">+63 (2) 8588-1926</p>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="disclaimer-container">
          <h5 class="sub-tilte-page">Disclaimer</h5>

          <p class="text-muted">
            The opinion, views and recommendations contained in this material were
            prepared by the Philstocks Research Team, individually and separately, based
            on their specific sector assignments, contextual framework, personal
            judgments, biases and prejudices, time horizons, methods and other factors.
            The reader is enjoined to take this into account when perusing and considering
            the contents of the report as a basis for their stock investment or trading
            decisions. Furthermore, projection made and presented in this report may
            change or be updated in between the periods of release. Ergo, the validity of
            the projections and/or estimates mentioned are good as of the date findicated
            and may be changed without immediate notification.
          </p>
          <p class="text-muted">
            This report is primarily intended for information purposes only and should not
            be considered as an exclusive basis for making investment decision. The
            recommendations contained in this report is not tailored-fit any particular
            investor type, situation, or objective and must not be taken as such.
            Determining the suitability of an investment remains within the province of
            the investor. Our estimates are based on information we believe to be
            reliable. Nevertheless, nothing in this report shall be construed as an offer
            of a guarantee of a return of any kind and at any time.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
